import type React from "react"
import { Loader2 } from "lucide-react"
import { cn } from "../../utils"

interface LoadingProps {
  className?: string
  size?: number
  text?: string
}

export const Loading: React.FC<LoadingProps> = ({ className, size = 24, text = "Loading..." }) => {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2", className)}>
      <Loader2 className="animate-spin" size={size} />
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  )
}

export const LoadingPage: React.FC<LoadingProps> = (props) => {
  return (
    <div className="flex h-[calc(100vh-4rem)] items-center justify-center">
      <Loading {...props} size={32} />
    </div>
  )
}

export const LoadingSection: React.FC<LoadingProps> = (props) => {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <Loading {...props} />
    </div>
  )
}
